import { render } from "./CIS_Resource-Benchmark-Version.vue?vue&type=template&id=72cbb46e"
import script from "./CIS_Resource-Benchmark-Version.vue?vue&type=script&lang=js"
export * from "./CIS_Resource-Benchmark-Version.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__